$(document).ready(function() {
    //if url has cart=open, trigger click .header__icon--cart, then remove param
    if (window.location.href.indexOf('cart=open') > -1) {
        $('#cart-icon-bubble')[0].click();
        window.history.pushState({}, document.title, window.location.pathname);
    }

    $('.custom-select').each(function(){
        const placeholder = $(this).attr('data-placeholder');
        $(this).customSelect({
            placeholder: `<span class="select-placeholder">${placeholder}</span>`
        });
    })
    $('.popup-overlay, .popup-close').on('click', function() {
        $('.popup').addClass('is-leaving');
        setTimeout(function() {
            $('body').css('overflow', 'auto');
            $('.popup').removeClass('active').removeClass('is-leaving');
        }, 300);
    });
    
    $(document).on('change','.custom-item-properties select', function(){
        const target = $(this).attr('data-target');
        const targetSelect = $(`#${target}`);
        const selected = $(this).parent().find('.custom-select__option--value').text();
        targetSelect.val(selected);
        targetSelect.trigger('change');
    });

    $(document).on('change','.custom-properties-hidden input', function(){
        const customPropertiesHidden = $('.custom-properties-hidden input');
        let requiredInputsCount = 0;
        const submitButton = $('.product-form__submit');
        const submitButtonMobile = $('.mobile-buy-button button');
        let errorText = '';

        customPropertiesHidden.each(function() {
            if ($(this).attr('required') && $(this).val() == '') {
                errorText = `<span>Select a ${$(this).attr('data-name')}</span>`;
                requiredInputsCount++;
            }
        });
        if (requiredInputsCount > 0) {
            submitButton.prop('disabled', true);
            submitButton.addClass('button-with-error-message');
            submitButton.find('.product-button-error').html(errorText);

            submitButtonMobile.prop('disabled', true);
            submitButtonMobile.addClass('button-with-error-message');
            submitButtonMobile.find('.product-button-error').html(errorText);
        }else{
            submitButton.prop('disabled', false);
            submitButton.removeClass('button-with-error-message');
            submitButton.find('.product-button-error').html('');

            submitButtonMobile.prop('disabled', false);
            submitButtonMobile.removeClass('button-with-error-message');
            submitButtonMobile.find('.product-button-error').html('');
        }
        
    });

    if($('.main-product').length){
        $('.product-image-mobile').flickity({
            cellAlign: 'left',
            contain: true,
            groupCells: 1,
            imagesLoaded: true,
            pageDots: false,
            watchCSS: true, 
            arrowShape: 'M45.7823 82L51.2449 76.5714L28.7561 53.9286H87V46.0714H28.7561L51.2449 23.5L45.7823 18L14 50L45.7823 82Z'
        });

    }
    
    $(document).on('click','.remove-cart-item-trigger', function(){
        $(this).parents('tr').find('.cart-remove-button')[0].click();
    });


    let firstTimeMenu = false;
    $(document).on('click','.header__icon--menu', function(){
        setTimeout(function(){
            const firstMenu = $(document).find('.menu-drawer__navigation > ul > li:first-child').addClass('is-open');
            const firstMenuSubmenu = firstMenu.find('.second-level');
            firstMenuSubmenu.outerHeight(firstMenu.find('.second-level > .menu-drawer__inner-submenu').outerHeight());
            firstMenu.siblings().removeClass('is-open').find('.second-level').outerHeight(0);
        }, 100);
    });


    $(document).on('click','.menu-drawer__menu-item', function(){
        const parent = $(this).parents('li');
        const submenu = parent.find('.second-level');
        parent.toggleClass('is-open');
        if(parent.hasClass('is-open')){
            submenu.outerHeight(parent.find('.second-level > .menu-drawer__inner-submenu').outerHeight());
        }else{
            submenu.outerHeight(0);
        }
        parent.siblings().removeClass('is-open').find('.second-level').outerHeight(0);
    });

    if($('#CartDrawer-Form').outerHeight() < $('.cart-drawer-items').outerHeight()){
        $('.cart-drawer-items').addClass('less-items');
    }

    $(document).on('click','.mobile-buy-button button:not([disabled])', function(){
        $(this).attr('disabled', 'disabled').addClass('loading');
        $(this).find('span').css('opacity', '0');
        $(this).find('.loading__spinner').removeClass('hidden');
        $('.product-form__submit')[0].click();
    });

    if($('.main-product').length){
        const visibleImage = $('.product-image-wrapper:not(.hidden)');
        if(visibleImage.length == 0){
            $('.product-image-wrapper').first().removeClass('hidden');
        }
    }

    $(document).on('click','.swatch-input.disabled .swatch-input__label', function(e){
        e.preventDefault();
    });

});